var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Excel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Excel",
    clipPath: "url(#clip-Excel)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-2",
    "data-name": "excel",
    transform: "translate(0.646 1.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M14.247,17.828H8.273V16.45a.458.458,0,0,0-.166-.354.452.452,0,0,0-.378-.1L.375,17.377A.458.458,0,0,0,0,17.828V27.939a.459.459,0,0,0,.375.451l7.353,1.379a.433.433,0,0,0,.085.008.46.46,0,0,0,.46-.46V27.939h5.975a.46.46,0,0,0,.46-.46V18.288A.46.46,0,0,0,14.247,17.828ZM6.32,24.42a.459.459,0,1,1-.691.6L4.293,23.5,3.121,25.005a.46.46,0,0,1-.726-.565l1.281-1.647L2.412,21.348a.46.46,0,0,1,.692-.6l1.147,1.311L5.612,20.3a.46.46,0,1,1,.725.565l-1.471,1.89Zm7.467,2.6H8.273V26.1H9.651a.46.46,0,1,0,0-.919H8.273v-.919H9.651a.46.46,0,0,0,0-.919H8.273v-.919H9.651a.46.46,0,0,0,0-.919H8.273v-.919H9.651a.46.46,0,1,0,0-.919H8.273v-.919h5.515Z",
    transform: "translate(0 -15.989)",
    fill: "#608603"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(11.03 3.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M385.379,144.011h-.919a.46.46,0,0,0,0,.919h.919a.46.46,0,1,0,0-.919Z",
    transform: "translate(-384 -144.011)",
    fill: "#608603"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(11.03 5.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M385.379,208.011h-.919a.46.46,0,0,0,0,.919h.919a.46.46,0,1,0,0-.919Z",
    transform: "translate(-384 -208.011)",
    fill: "#608603"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(11.03 7.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M385.379,272.011h-.919a.46.46,0,0,0,0,.919h.919a.46.46,0,1,0,0-.919Z",
    transform: "translate(-384 -272.011)",
    fill: "#608603"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(11.03 9.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M385.379,336.011h-.919a.46.46,0,0,0,0,.919h.919a.46.46,0,1,0,0-.919Z",
    transform: "translate(-384 -336.011)",
    fill: "#608603"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.62609971357cd7cc0e316e727c82a7e8.svg";
export { ForwardRef as ReactComponent };